import { RELEVANCY_SORT } from '../../model/query/sortOptions';
import { sanitizeArea, sanitizeLocation } from './sanitize';

function locationsGenerator(locations = []) {
  const validLocations = locations.map(sanitizeLocation).filter(Boolean);
  if (validLocations.length < 2) return undefined;

  const locationsValue = validLocations.join(',');

  return { locations: locationsValue };
}

function floorAreaGenerator(minFloorArea, maxFloorArea) {
  return {
    minFloorArea: sanitizeArea(minFloorArea),
    maxFloorArea: sanitizeArea(maxFloorArea),
  };
}

function landAreaGenerator(minLandArea, maxLandArea) {
  return {
    minSiteArea: sanitizeArea(minLandArea),
    maxSiteArea: sanitizeArea(maxLandArea),
  };
}

function currentLocationGenerator(location) {
  if (location && location.length !== 0) {
    return {
      where: location.join(','),
      currentLocation: true,
    };
  }
}

function activeSortGenerator(sortObject = {}) {
  return (sortObject.value && sortObject.value !== RELEVANCY_SORT.value) ? { activeSort: sortObject.value } : undefined;
}

function keywordsGenerator(keywords) {
  if (keywords) {
    return { keywords: keywords.replace(/\*+/g, '').replace(/ +/g, '+') };
  }
}

function searchWithinGenerator(searchWith) {
  if (searchWith) {
    return { includePropertiesWithin: searchWith };
  }
}

function parkingSpacesGenerator(parkingSpaces) {
  if (parkingSpaces) {
    return { numParkingSpaces: parkingSpaces };
  }
}

function tenureTypeGenerator(tenureType) {
  if (tenureType && tenureType !== 'any') {
    return { tenure: tenureType };
  }
}

function energyEfficiencyGenerator(energyEfficiency) {
  if (energyEfficiency) {
    return { energyEfficiency };
  }
}

function priceGenerator(minPrice, maxPrice) {
  if (minPrice || maxPrice) {
    const price = {};
    if (minPrice && minPrice > 0) price.minPrice = minPrice;
    if (maxPrice && maxPrice > 0) price.maxPrice = maxPrice;
    return price;
  }
}

function propertyTypesGenerator(propertyTypes = []) {
  const multiplePropertyTypesString = propertyTypes.length > 1 && propertyTypes.join(',');

  if (multiplePropertyTypesString) {
    return { propertyTypes: multiplePropertyTypesString };
  }
}

module.exports = {
  locationsGenerator,
  floorAreaGenerator,
  landAreaGenerator,
  currentLocationGenerator,
  activeSortGenerator,
  searchWithinGenerator,
  keywordsGenerator,
  parkingSpacesGenerator,
  energyEfficiencyGenerator,
  tenureTypeGenerator,
  priceGenerator,
  propertyTypesGenerator,
};
